<div
    class="tw-mx-auto tw-p-[20px] tw-pb-[50px] tw-relative tw-flex tw-flex-col tw-gap-[15px] tw-bg-white tw-rounded-[8px] md:tw-min-h-[550px] tw-shadow-lg hover:tw-cursor-pointer"
>
    <div class="tw-min-h-[150px] tw-flex tw-justify-center tw-items-center">
        <img
            [src]="mitiProduct.image"
            alt="Miti-Logo"
            class="tw-w-auto tw-max-h-[100px]"
        />
    </div>
    <span class="!tw-font-semibold !tw-uppercase tw-text-[#0F268F]">{{
        mitiProduct.prodFi
    }}</span>
    <h3
        class="!tw-text-[18px] tw-text-[#0F268F] tw-h-[90px] tw-flex tw-items-center !tw-mb-0"
    >
        {{ mitiProduct.productName }}
    </h3>
    <p *ngIf="selectedLanguage === 'en'">
        {{
            mitiProduct.prodShortDesc.length > 200
                ? mitiProduct.prodShortDesc.slice(0, 200) + "..."
                : mitiProduct.prodShortDesc
        }}
    </p>
    <p *ngIf="selectedLanguage === 'bm'">
        {{
            mitiProduct.prodShortDescBm.length > 200
                ? mitiProduct.prodShortDescBm.slice(0, 200) + "..."
                : mitiProduct.prodShortDescBm
        }}
    </p>

    <a
        (click)="goToDetails()"
        [attr.ga-event-id]="
            mitiProduct.prodCode.toLowerCase() + '_button_grants_click'
        "
        [attr.ga-event-category]="'Grants Button'"
        [attr.ga-event-label]="mitiProduct.productName + '  Grants Card Click'"
        ga-track="track"
        class="tw-block tw-absolute tw-bottom-[10px] tw-left-[50%] tw-translate-x-[-50%] tw-font-semibold tw-text-center tw-w-full tw-max-w-[70%] tw-bg-[#FF8717] tw-text-white tw-rounded-full tw-shadow-lg tw-mx-auto md:tw-mx-0 tw-py-[10px]"
    >
        {{ selectedLanguage == "en" ? "View Details" : "Lihat Butiran" }}
    </a>
</div>
